<div class="container flex flex-col flex-grow">
  @if (editingOpen()) {
    <app-edit-greetings (editingOpen)="onBack()"
                        [data]="editingAiSettings()"
                        [settingType]="aiSettingType()"
                        (editedSetting)="onSave($event)"
                        (deletedSetting)="onDelete($event)"/>
  } @else {
    <div>

      <div class="px-5 pt-5">
        <span class="title">{{ "REVIEWS.DEFAULT_REPLY_LANGUAGE" | translate }}</span>
        <div class="languageDropdown">
          <mat-form-field id="select-form" appearance="fill">
            <mat-select [ngModel]="defaultLanguage()"
                        (ngModelChange)="updateDefaultLanguageAndReviewType($event,
                          defaultLanguageReviewType(),
                          defaultLanguage())"
                        [placeholder]="('SELECT' | translate)"
                        (closed)="searchFieldFormControl.reset()">
              <mat-select-trigger>
                <span class="flagContainer">{{ getEmoji(defaultLanguage()) }}</span>
                <span
                    [innerHTML]="getLanguageDisplayName(defaultLanguage())
                      | highlightKeyword: searchFieldFormControl?.value?.trim()"></span>
              </mat-select-trigger>

              <!-- Search-field for dropdown-option-search -->
              <div class="stickyHeader">
                <mat-form-field id="search-form" appearance="fill">
                  <mat-icon svgIcon="search" matPrefix
                            [class.text-primary]="searchFieldFormControl?.value?.trim().length"></mat-icon>
                  <input matInput
                         appGxInput
                         [formControl]="searchFieldFormControl"
                         (keydown)="$event.stopPropagation()"

                         [placeholder]="'MULTISELECT.SEARCH' | translate">
                  <button mat-icon-button matSuffix
                          [class.invisible]="!searchFieldFormControl?.value?.length"
                          aria-label="Clear"
                          (click)="searchFieldFormControl.reset()">
                    <mat-icon svgIcon="close"></mat-icon>
                  </button>
                </mat-form-field>
                <mat-divider></mat-divider>
              </div>

              <!-- Dropdown options -->
              @for (lang of defaultLanguages(); track lang.key; ) {
                <mat-option [class.hidden]="isHidden(lang)"
                            [value]="lang">
                  <span class="flagContainer">{{ getEmoji(lang) }}</span>
                  <span
                      [innerHTML]="getLanguageDisplayName(lang)
                      | highlightKeyword: searchFieldFormControl?.value?.trim()"></span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="px-5 pt-5">
        <span class="title">{{ "REVIEWS.DEFAULT_REPLY_LANGUAGE_USE" | translate }}</span>
        <mat-button-toggle-group class="toggleButtons"
                                 [value]="defaultLanguageReviewType()"
                                 (change)="updateDefaultLanguageAndReviewType($event,
                                   defaultLanguageReviewType(),
                                   defaultLanguage())">
          <mat-button-toggle
              [value]="ReviewType.ALL">{{ "REVIEWS.DOWNLOAD.ALL_REVIEWS" | translate }}
          </mat-button-toggle>
          <mat-button-toggle
              [value]="ReviewType.STAR_ONLY">{{ "REVIEWS.STAR_ONLY_REVIEWS" | translate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <div class="px-5 pt-5">
        <span class="title">{{ "REVIEWS.REPLY_STYLE" | translate }}</span>
        <mat-button-toggle-group class="toggleButtons"
                                 [value]="replyStyle()"
                                 (change)="onStyleSelected($event)">
          <mat-button-toggle
              [value]="ReplyStyle.STANDARD">{{ "REVIEWS.STANDARD_REPLY_STYLE" | translate }}
          </mat-button-toggle>
          <mat-button-toggle
              [value]="ReplyStyle.FORMAL">{{ "REVIEWS.FORMAL_REPLY_STYLE" | translate }}
          </mat-button-toggle>
          <mat-button-toggle
              [value]="ReplyStyle.INFORMAL">{{ "REVIEWS.INFORMAL_REPLY_STYLE" | translate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>


      <div class="px-5 pt-5">
        <span class="title">{{ "REVIEWS.GREETING" | translate }}</span>
        <mat-radio-group
            required="false"
            aria-labelledby="greetings"
            class="flex flex-col"
            (change)="onGreetingSelected($event, selectedGreeting())">

          @for (greeting of greetings(); track greeting.id) {
            <div class="greeting-closings-container flex flex-row items-center justify-between">
              <mat-radio-button [value]="greeting"
                                [checked]="greeting.selected">
                <div class="flex flex-col">
                  <span class="greet-close-name">{{ greeting.title }}</span>
                  <span [innerHTML]="generateTemplateInnerHTML(greeting.text)"
                        class="greet-close-text"></span>
                </div>
              </mat-radio-button>
              <button
                  mat-icon-button
                  class="editButton"
                  (click)="onOpenEdit(greeting)">
                <mat-icon class="editIcon" svgIcon="edit_outline"></mat-icon>
              </button>
            </div>
          }
          <div class="greeting-closings-container flex flex-row items-center justify-between">
            <mat-radio-button [value]="false" [checked]="!selectedGreeting()">
              <span class="greet-close-name">{{ "REVIEWS.NO_CUSTOM_GREETING" | translate }}</span>
            </mat-radio-button>
          </div>
        </mat-radio-group>
        <div class="flex flex-row items-center justify-between createNew">
          <button mat-button
                  (click)="createNew(AiSettingsType.GREETING)">
            <mat-icon svgIcon="add_circle_outline"></mat-icon>
            <span>{{ "REVIEWS.NEW_GREETING" | translate }}</span>
          </button>
        </div>
      </div>


      <div class="px-5 pt-5">
        <span class="title">{{ "REVIEWS.CLOSING" | translate }}</span>
        <mat-radio-group
            required="false"
            aria-labelledby="closings"
            class="flex flex-col"
            (change)="onClosingSelected($event, selectedClosing())">

          @for (closing of closings(); track closing.id) {
            <div class="greeting-closings-container flex flex-row items-center justify-between">
              <mat-radio-button [value]="closing"
                                [checked]="closing.selected">
                <div class="flex flex-col">
                  <span class="greet-close-name">{{ closing.title }}</span>
                  <span [innerHTML]="generateTemplateInnerHTML(closing.text)"
                        class="greet-close-text"></span>
                </div>
              </mat-radio-button>
              <button mat-icon-button
                      class="editButton"
                      matTooltip="{{'EDIT' | translate}}"
                      (click)="onOpenEdit(closing)">
                <mat-icon class="editIcon" svgIcon="edit_outline"></mat-icon>
              </button>
            </div>
          }
          <div class="greeting-closings-container flex flex-row items-center justify-between">
            <mat-radio-button [value]="false" [checked]="!selectedClosing()">
              <span class="greet-close-name">{{ "REVIEWS.NO_CUSTOM_CLOSING" | translate }}</span>
            </mat-radio-button>
          </div>
        </mat-radio-group>

        <div class="flex flex-row items-center justify-between createNew">
          <button mat-button
                  (click)="createNew(AiSettingsType.CLOSING)">
            <mat-icon svgIcon="add_circle_outline"></mat-icon>
            <span>{{ "REVIEWS.NEW_CLOSING" | translate }}</span>
          </button>
        </div>
      </div>

    </div>
  }

</div>
